module.exports = __webpack_public_path__ + "dashboard/img/go.bf1358a20123f5a278b098475fb51985.svg";